import React, { Component } from 'react';
import '../styles/Summary.scss';
import '../styles/Report.scss';
import '../styles/CommonStyle.scss';
import loader from '../images/loader.gif';
import Footer from './Footer';
import SideBar from './SideBar';
import Header from './Header';
import '../styles/CommonStyle.scss';
import { withTranslation } from 'react-i18next';
import { getPoolInformation } from '../services/tenant-identity-service';

class Report extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { t } = this.props;

        return (
            <main className="Dash-board">
                <div className="Dash-board-div">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                                <SideBar {...this.props} />
                            </div>
                            <div className="col-md-9">
                                <Header {...this.props} />
                                <div className="dash-board-content-sec">

                                    <div className="summary-details">
                                        <div className="user-details">
                                            <div className="active-subscription-bill">{t('Lorem ipsum dolor sit amet, consectetur adipiscing elit.')}
                                                <br></br>{t('Curabitur auctor massa lobortis,')}{t('vehicula eros vel,')}{t('commodo quam in')} <b>{t('Active Plan')}</b></div>
                                        </div>
                                    </div>

                                    <div className="reports_main_div">
                                        <div className="display_inline_block">
                                            <div className="report_box"></div>
                                            <div><p className="report_text font_16">{t('Invoice')}# 12234</p></div>
                                            <div className="report_text_date font_16">{t('October 2020')}</div>
                                        </div>
                                        <div className="display_inline_block">
                                            <div className="report_box"></div>
                                            <div><p className="report_text font_16">{t('Invoice')}# 12234</p></div>
                                            <div className="report_text_date font_16">{t('October')} 2020</div>
                                        </div>
                                        <div className="display_inline_block">
                                            <div className="report_box"></div>
                                            <div><p className="report_text font_16">{t('Invoice')}# 12234</p></div>
                                            <div className="report_text_date font_16">{t('October')}2020</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </main>
        )
    }
};
export default withTranslation()(Report)